(function () {
  'use strict';

  var DEBOUNCE_MS = 200;
  var MIN_CHARS = 2;

  function formatDuration(seconds) {
    var mins = Math.round(Number(seconds || 0) / 60);
    if (mins < 1) return '< 1 min';
    if (mins < 60) return mins + ' min';
    return Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
  }

  function sendSearchClick(term, slug) {
    if (!term || !slug || !navigator.sendBeacon) return;
    try {
      var body = JSON.stringify({ term: term, slug: slug });
      var blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon('/api/courses/search-click', blob);
    } catch (e) { /* ignore */ }
  }

  function buildSeeAllUrl(query, form) {
    var params = new URLSearchParams();
    params.set('search', query);
    if (form) {
      form.querySelectorAll('input[type="hidden"]').forEach(function (input) {
        if (input.name && input.value) {
          params.set(input.name, input.value);
        }
      });
    }
    return '/courses?' + params.toString();
  }

  function initSearch(root) {
    var input = root.querySelector('[data-course-search-input]');
    var dropdown = root.querySelector('[data-course-search-dropdown]');
    var form = root.querySelector('[data-course-search-form]');
    if (!input || !dropdown) return;

    var debounceTimer = null;
    var abortController = null;
    var activeIndex = -1;
    var currentResults = [];

    function closeDropdown() {
      dropdown.hidden = true;
      dropdown.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
      currentResults = [];
    }

    function setActiveOption(index) {
      var options = dropdown.querySelectorAll('[role="option"]');
      options.forEach(function (opt, i) {
        var isActive = i === index;
        opt.classList.toggle('course-search__option--active', isActive);
        opt.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive) {
          input.setAttribute('aria-activedescendant', opt.id);
        }
      });
      activeIndex = index;
    }

    function renderResults(data) {
      dropdown.innerHTML = '';
      currentResults = data.results || [];

      if (!currentResults.length) {
        var empty = document.createElement('div');
        empty.className = 'course-search__empty';
        empty.textContent = 'No courses found';
        dropdown.appendChild(empty);
        dropdown.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      currentResults.forEach(function (item, i) {
        var option = document.createElement('a');
        option.href = item.url;
        option.className = 'course-search__option';
        option.setAttribute('role', 'option');
        option.id = 'course-search-opt-' + i;
        option.setAttribute('aria-selected', 'false');
        option.dataset.slug = item.slug;

        var title = document.createElement('span');
        title.className = 'course-search__option-title';
        title.textContent = item.title;
        option.appendChild(title);

        var meta = document.createElement('span');
        meta.className = 'course-search__option-meta';
        var metaParts = [];
        if (item.category) metaParts.push(item.category);
        if (item.difficulty) metaParts.push(item.difficulty);
        if (item.duration_label) metaParts.push(item.duration_label);
        else if (item.duration) metaParts.push(formatDuration(item.duration));
        meta.textContent = metaParts.join(' · ');
        option.appendChild(meta);

        option.addEventListener('click', function (e) {
          sendSearchClick(input.value.trim(), item.slug);
        });

        dropdown.appendChild(option);
      });

      if (data.total > currentResults.length) {
        var footer = document.createElement('a');
        footer.href = buildSeeAllUrl(data.query, form);
        footer.className = 'course-search__footer';
        footer.setAttribute('role', 'option');
        footer.id = 'course-search-opt-all';
        footer.textContent = 'See all ' + data.total + ' results';
        dropdown.appendChild(footer);
      }

      dropdown.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    }

    function fetchSuggestions(query) {
      if (abortController) {
        abortController.abort();
      }
      abortController = new AbortController();

      fetch('/api/courses/suggest?q=' + encodeURIComponent(query), {
        signal: abortController.signal,
        headers: { Accept: 'application/json' },
      })
        .then(function (res) {
          if (!res.ok) throw new Error('suggest failed');
          return res.json();
        })
        .then(function (data) {
          if (input.value.trim() !== query) return;
          renderResults(data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          closeDropdown();
        });
    }

    function onInput() {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < MIN_CHARS) {
        closeDropdown();
        return;
      }

      debounceTimer = setTimeout(function () {
        fetchSuggestions(query);
      }, DEBOUNCE_MS);
    }

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', function (e) {
      if (dropdown.hidden) return;

      var options = dropdown.querySelectorAll('[role="option"]');
      if (!options.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = activeIndex < options.length - 1 ? activeIndex + 1 : 0;
        setActiveOption(next);
        options[next].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = activeIndex > 0 ? activeIndex - 1 : options.length - 1;
        setActiveOption(prev);
        options[prev].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        var selected = options[activeIndex];
        if (selected && selected.href) {
          if (selected.dataset && selected.dataset.slug) {
            sendSearchClick(input.value.trim(), selected.dataset.slug);
          }
          window.location.href = selected.href;
        }
      } else if (e.key === 'Escape') {
        closeDropdown();
      }
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closeDropdown();
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        closeDropdown();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-course-search]').forEach(initSearch);
  });
})();
